import { Translation } from '@softline/ui-core';
import { Signal } from '@angular/core';
import { PageFilterFactoryRef } from './page-filter.function';

export interface PageFilterGroupOptions {
  key: string;
  title: Signal<Translation>;
  order?: number;
}

export function pageFilterGroup(ref: PageFilterFactoryRef, options: PageFilterGroupOptions): void {
  ref.groups.push({
    ...options,
    order: options.order ?? ref.groups.length
  });
}
